// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";

const getStorageKey = () => {
  const domain = window.location.origin;
  // Usiamo sessionStorage per lo stato transazionale, localStorage per i token utente
  // La chiave specifica per lo stato non è più necessaria se usiamo sessionStorage di default
  // Ma manteniamo una chiave unica per i dati utente in localStorage
  return `oidc.user.${domain.replace(/[^\w]/g, '_')}`;
};

const cognitoAuthConfig = {
  authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_QQpl6RjRr",
  client_id: "5jepihvgjtg4jcou8vepf88ahb",
  redirect_uri: "https://assistant.muvbcorp.com/", // Assicurati sia corretta e registrata in Cognito
  response_type: "code",
  scope: "email openid profile",
  post_logout_redirect_uri: "https://assistant.muvbcorp.com/",


  // 2. Aggiungi il callback per pulire l'URL
  onSigninCallback: (user) => {
    console.log("OIDC Signin Callback executed.");
    if (user && !user.error) {
      // Pulisce code e state dalla query string '?'
      const searchParams = new URLSearchParams(window.location.search);
      const needsSearchClean = searchParams.has('code') || searchParams.has('state');
      if (needsSearchClean) {
         searchParams.delete('code');
         searchParams.delete('state');
         // Rimuovi anche eventuali parametri di errore OIDC
         searchParams.delete('error');
         searchParams.delete('error_description');
         searchParams.delete('error_uri');
         const newSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';
         const cleanUrl = window.location.pathname + newSearch + window.location.hash;
         console.log("OIDC Signin Callback: Cleaning URL search params. New URL:", cleanUrl);
         window.history.replaceState({}, document.title, cleanUrl);
      }

      // Pulisce code e state dall'hash '#' (meno comune con response_type=code, ma per sicurezza)
      const hashParams = new URLSearchParams(window.location.hash.substring(1)); // Rimuove # iniziale
       const needsHashClean = hashParams.has('code') || hashParams.has('state');
       if (needsHashClean) {
           hashParams.delete('code');
           hashParams.delete('state');
           hashParams.delete('error');
           hashParams.delete('error_description');
           hashParams.delete('error_uri');
           const newHash = hashParams.toString() ? `#${hashParams.toString()}` : '';
           const cleanUrl = window.location.pathname + window.location.search + newHash;
           console.log("OIDC Signin Callback: Cleaning URL hash params. New URL:", cleanUrl);
           window.history.replaceState({}, document.title, cleanUrl);
       }
    } else if (user && user.error) {
        console.error("OIDC Signin Callback received an error:", user.error, user.error_description);
        // Anche in caso di errore nel callback, prova a pulire l'URL da parametri potenzialmente problematici
        // (La libreria potrebbe aver già gestito l'errore, ma pulire è più sicuro)
        window.history.replaceState({}, document.title, window.location.pathname);
    }
  },

  // --- IMPOSTAZIONI ESISTENTI (rivedile se necessario) ---
  // Rimuovi storeKey se torni a sessionStorage per lo state,
  // la libreria userà i suoi default. Altrimenti lasciala se vuoi prefisso custom per localStorage.
  // storeKey: getStorageKey(), // <-- Probabilmente non più necessario se usi default storage

  loadUserInfo: true, // Ok
  monitorSession: false, // Valuta se attivarlo (true) per controlli sessione IdP
  prompt: "login", // Mantiene richiesta login a Cognito, valuta se rimuoverlo per SSO migliore

  // Gestione localhost (ok)
  ...(window.location.hostname === 'localhost' && {
    redirect_uri: window.location.origin + "/", // Aggiungi '/' se necessario
  }),
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Prova SENZA StrictMode SE le modifiche sopra non bastano, per diagnosi
  // <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  // </React.StrictMode>
);